// extracted by mini-css-extract-plugin
export default {"products":"Vz-z","card":"Wz-z","oosMessaging":"Xz-z"};